module.exports = __webpack_public_path__ + "media/svg/um-e834167e.svg";